import axios from 'axios';
import {
  GET_MATCH_CARD_EVENT_REQUEST,
  GET_MATCH_CARD_EVENT_SUCCESS,
  GET_MATCH_CARD_EVENT_FAILURE,
  GET_MATCH_CARD_HEADER_REQUEST,
  GET_MATCH_CARD_HEADER_SUCCESS,
  GET_MATCH_CARD_HEADER_FAILURE,
  GET_MATCH_CARD_HEADER_STATISTICS_REQUEST,
  GET_MATCH_CARD_HEADER_STATISTICS_SUCCESS,
  GET_MATCH_CARD_HEADER_STATISTICS_FAILURE,
  GET_SMART_ANALYSIS_REQUEST,
  GET_SMART_ANALYSIS_SUCCESS,
  GET_SMART_ANALYSIS_FAILURE,
  GET_AUTHOR_COMMENTS_REQUEST,
  GET_AUTHOR_COMMENTS_SUCCESS,
  GET_AUTHOR_COMMENTS_FAILURE,
  GET_INJURED_BANNED_DATA_REQUEST,
  GET_INJURED_BANNED_DATA_SUCCESS,
  GET_INJURED_BANNED_DATA_FAILURE,
  GET_MATCH_CARD_STANDINGS_REQUEST,
  GET_MATCH_CARD_STANDINGS_SUCCESS,
  GET_MATCH_CARD_STANDINGS_FAILURE,
  GET_STATISTICS_DATA_REQUEST,
  GET_STATISTICS_DATA_SUCCESS,
  GET_STATISTICS_DATA_FAILURE,
  GET_MATCH_CARD_DETAILS_REQUEST,
  GET_MATCH_CARD_DETAILS_SUCCESS,
  GET_MATCH_CARD_DETAILS_FAILURE,
  GET_LIVE_STATISTICS_REQUEST,
  GET_LIVE_STATISTICS_SUCCESS,
  GET_LIVE_STATISTICS_FAILURE,
  GET_MATCH_CARD_ODDS_REQUEST,
  GET_MATCH_CARD_ODDS_SUCCESS,
  GET_MATCH_CARD_ODDS_FAILURE,

  GET_CLICKED_POINT,

  RESET_MATCH_CARD,
  GET_MATCH_CARD_LEAGUE_EVENTS_REQUEST,
  GET_MATCH_CARD_LEAGUE_EVENTS_SUCCESS,
  GET_MATCH_CARD_LEAGUE_EVENTS_FAILURE,

  GET_MATCH_CARD_STATISTIC_MARKETS_REQUEST,
  GET_MATCH_CARD_STATISTIC_MARKETS_SUCCESS,
  GET_MATCH_CARD_STATISTIC_MARKETS_FAILURE,

  GET_MATCH_CARD_TRIBUN_COUPONS_REQUEST,
  GET_MATCH_CARD_TRIBUN_COUPONS_SUCCESS,
  GET_MATCH_CARD_TRIBUN_COUPONS_FAILURE,
  SET_MATCHCARD_LAST_FEEDS,
  GET_MATCH_CARD_TRIBUN_COUPONS_LOADMORE_SUCCESS,

  GET_PERSONAL_MARKET_IDS_REQUEST,
  GET_PERSONAL_MARKET_IDS_FAILURE,
  GET_PERSONAL_MARKET_IDS_SUCCESS,
  GET_POPULAR_MARKET_IDS_REQUEST,
  GET_POPULAR_MARKET_IDS_FAILURE,
  GET_POPULAR_MARKET_IDS_SUCCESS,
  GET_MATCH_CARD_IMPORTANT_MOMENTS_REQUEST,
  GET_MATCH_CARD_IMPORTANT_MOMENTS_SUCCESS,
  GET_MATCH_CARD_IMPORTANT_MOMENTS_FAILURE,

  GET_IMPORTANT_MOMENTS_PLAYER_REQUEST,
  GET_IMPORTANT_MOMENTS_PLAYER_SUCCESS,
  GET_IMPORTANT_MOMENTS_PLAYER_FAILURE,

  AUTHENTICATE_IMPORTANT_MOMENT_STREAM_REQUEST,
  AUTHENTICATE_IMPORTANT_MOMENT_STREAM_SUCCESS,
  AUTHENTICATE_IMPORTANT_MOMENT_STREAM_FAILURE,

  GET_MULTIPLE_LMT_HEADER_REQUEST,
  GET_MULTIPLE_LMT_HEADER_SUCCESS,
  GET_MULTIPLE_LMT_HEADER_FAILURE,

  GET_PLAYER_ANALYSIS_REQUEST,
  GET_PLAYER_ANALYSIS_SUCCESS,
  GET_PLAYER_ANALYSIS_FAILURE,

  CHECK_PLAYER_ANALYSIS_AVAILABILITY_REQUEST,
  CHECK_PLAYER_ANALYSIS_AVAILABILITY_SUCCESS,
  CHECK_PLAYER_ANALYSIS_AVAILABILITY_FAILURE,
} from 'Store/constants';
import errorMessage from 'Store/actions/errorMessage';
import ProjectConfig from 'ProjectConfig';
import { trackMatchCard } from 'Utils/analytics';
import LocalStorage from 'Utils/localStorage';
import { TRIBUN_FILTER_SORT_OPTIONS } from 'Store/constants/tribun';
import { openModal } from 'Store/actions';
import { replaceUrlWithPublicUrl } from 'Utils/replaceUrlWithPublicUrl';
import { getTribunCouponDetails } from './tribunActions';
import { createLiveStreamGeoBlockError } from 'Utils/liveStreamGeoBlockHelper';

const API_GATEWAY = ProjectConfig.API_GATEWAY;
const { SORT, FILTER_V2 } = TRIBUN_FILTER_SORT_OPTIONS;
const inFlightHeaderRequests = new Map();

const shouldExcludeBahistaAuthors = (availableTabs = []) => {
  if (!Array.isArray(availableTabs)) return false;
  return availableTabs.some(tab => (tab.type || tab.tabType) === 'BAHISTA');
};

const getPerformLaunchUrl = launchResponse => {
  const streamLaunchers = launchResponse?.launchInfo?.streamLauncher;
  if (!Array.isArray(streamLaunchers)) {
    return null;
  }

  const httpsLauncher = streamLaunchers.find(item => typeof item?.launcherURL === 'string' && item.launcherURL.startsWith('https'));
  if (httpsLauncher?.launcherURL) {
    return httpsLauncher.launcherURL;
  }

  const fallbackLauncher = streamLaunchers.find(item => typeof item?.launcherURL === 'string');
  return fallbackLauncher?.launcherURL || null;
};

export const getMatchCardEvent = eventId => async dispatch => {
  try {
    dispatch({
      type: GET_MATCH_CARD_EVENT_REQUEST
    });

    const res = await axios.get(`/v3/mobile/aggregator/gamelist/events/${eventId}`);

    dispatch({
      type: GET_MATCH_CARD_EVENT_SUCCESS,
      payload: res.data
    });

  } catch (e) {
    dispatch({
      type: GET_MATCH_CARD_EVENT_FAILURE,
      payload: e.response?.data || errorMessage
    });
  }
};

export const getClickedPoint = clickedPoint => dispatch => {
  try {
    dispatch({
      type: GET_CLICKED_POINT,
      payload: clickedPoint
    });

  } catch (e) {
    return;
  }
};


export const getMatchCardOdds = (eventId, options = { isPopular: false, sportType: '' }) => async dispatch => {
  try {
    const { isPopular = false, sportType } = options;

    dispatch({
      type: GET_MATCH_CARD_ODDS_REQUEST
    });

    // isLiveEvent query parameter is redundant but api needs that, true or false returns the same response
    const res = await axios.get(`${API_GATEWAY}/v3/mobile/aggregator/match-card/${eventId}/odds?isLiveEvent=true&isPopular=${isPopular}`);

    if (res.data.status?.code >= 400) {
      throw ('error');
    }
    dispatch({
      type: GET_MATCH_CARD_ODDS_SUCCESS,
      payload: {
        data: res.data,
        sportType: sportType,
      }
    });
  } catch (err) {
    dispatch({
      type: GET_MATCH_CARD_ODDS_FAILURE,
      payload: 'Not Fetched'
    });
  }
};


export const getSmartAnalysis = eventId => async dispatch => {
  try {
    dispatch({
      type: GET_SMART_ANALYSIS_REQUEST
    });
    const res = await axios.get(`${API_GATEWAY}/mobile/match-card/v2/${eventId}/smart-analysis`);

    dispatch({
      type: GET_SMART_ANALYSIS_SUCCESS,
      payload: res.data
    });

  } catch (e) {
    dispatch({
      type: GET_SMART_ANALYSIS_FAILURE,
      payload: e.response?.data || errorMessage
    });
  }
};

export const getAuthorComments = eventId => async dispatch => {
  try {
    dispatch({
      type: GET_AUTHOR_COMMENTS_REQUEST
    });

    const res = await axios.get(`${API_GATEWAY}/cms/eventInfo/comment/sbsEvent/${eventId}`);

    dispatch({
      type: GET_AUTHOR_COMMENTS_SUCCESS,
      payload: res.data?.data || []
    });

  } catch (e) {

    dispatch({
      type: GET_AUTHOR_COMMENTS_FAILURE,
      payload: e.response?.data || errorMessage
    });
  }
};

export const getAuthorCommentsOnMatchCard = (eventId, options = {}) => async (dispatch, getState) => {
  try {
    dispatch({
      type: GET_AUTHOR_COMMENTS_REQUEST
    });

    const excludeBahista = options.excludeBahista
      ?? shouldExcludeBahistaAuthors(getState()?.matchCard?.header?.data?.availableTabs);
    const res = await axios.get(`${API_GATEWAY}/v1/authors/comment/${eventId}?excludeBahista=${excludeBahista === true}`);

    dispatch({
      type: GET_AUTHOR_COMMENTS_SUCCESS,
      payload: res.data?.data || []
    });

  } catch (e) {

    dispatch({
      type: GET_AUTHOR_COMMENTS_FAILURE,
      payload: e.response?.data || errorMessage
    });
  }
};

export const getInjuredBannedData = eventId => async dispatch => {
  try {
    dispatch({
      type: GET_INJURED_BANNED_DATA_REQUEST
    });

    const res = await axios.get(`${API_GATEWAY}/mobile/match-card/${eventId}/missing-players`);
    dispatch({
      type: GET_INJURED_BANNED_DATA_SUCCESS,
      payload: res.data
    });

  } catch (e) {
    dispatch({
      type: GET_INJURED_BANNED_DATA_FAILURE,
      payload: e.response?.data || errorMessage
    });
  }
};

export const getStandingData = eventId => async dispatch => {
  try {
    dispatch({
      type: GET_MATCH_CARD_STANDINGS_REQUEST
    });

    const res = await axios.get(`${API_GATEWAY}/mobile/match-card/${eventId}/standing`);

    dispatch({
      type: GET_MATCH_CARD_STANDINGS_SUCCESS,
      payload: res.data
    });

  } catch (e) {

    dispatch({
      type: GET_MATCH_CARD_STANDINGS_FAILURE,
      payload: e.response?.data || errorMessage
    });
  }
};

export const getMatchCardStatistics = eventId => async dispatch => {
  try {
    dispatch({
      type: GET_STATISTICS_DATA_REQUEST
    });

    const res = await axios.get(`${API_GATEWAY}/mobile/match-card/${eventId}/statistics`);

    dispatch({
      type: GET_STATISTICS_DATA_SUCCESS,
      payload: res.data,
      eventId: eventId
    });

  } catch (e) {
    dispatch({
      type: GET_STATISTICS_DATA_FAILURE,
      payload: e.response?.data || errorMessage
    });
  }
};

export const getMatchCardDetails = eventId => async (dispatch, getState) => {
  try {
    const state = getState();
    const cache = state.matchCard.details.cache;
    const cachedData = cache[eventId];
    
    const CACHE_EXPIRY_TIME = 30 * 60 * 1000;
    const now = Date.now();
    
    if (cachedData && (now - cachedData.timestamp) < CACHE_EXPIRY_TIME) {
      dispatch({
        type: GET_MATCH_CARD_DETAILS_SUCCESS,
        payload: cachedData.data,
        eventId: eventId
      });
      return;
    }

    dispatch({
      type: GET_MATCH_CARD_DETAILS_REQUEST
    });

    const res = await axios.get(`${API_GATEWAY}/mobile/match-card/event/${eventId}/detail`);

    dispatch({
      type: GET_MATCH_CARD_DETAILS_SUCCESS,
      payload: res.data,
      eventId: eventId
    });
  } catch (e) {
    dispatch({
      type: GET_MATCH_CARD_DETAILS_FAILURE,
      payload: e.response?.data || errorMessage
    });
  }
};

export const getLiveStatistics = eventId => async dispatch => {
  try {
    dispatch({
      type: GET_LIVE_STATISTICS_REQUEST
    });
    
    const res = await axios.get(`${API_GATEWAY}/mobile/match-card/v2/${eventId}/livestatistics`);

    dispatch({
      type: GET_LIVE_STATISTICS_SUCCESS,
      payload: res.data,
      eventId: eventId
    });
  } catch (e) {
    dispatch({
      type: GET_LIVE_STATISTICS_FAILURE,
      payload: e.response && e.response.data || errorMessage
    });
  }
};

export const resetMatchCard = () => dispatch => {
  dispatch({
    type: RESET_MATCH_CARD
  });
};

export const getLeagueEvents = eventId => async dispatch => {
  try {
    dispatch({ type: GET_MATCH_CARD_LEAGUE_EVENTS_REQUEST });

    const res = await axios.get(`${API_GATEWAY}/v3/mobile/aggregator/match-card/${eventId}/league-events`);

    dispatch({
      type: GET_MATCH_CARD_LEAGUE_EVENTS_SUCCESS,
      payload: res.data
    });

    return res.data;
  } catch (e) {
    dispatch({
      type: GET_MATCH_CARD_LEAGUE_EVENTS_FAILURE,
      payload: e.response && e.response.data || errorMessage
    });

    throw e;
  }
};

export const getMatchCardStatisticMarkets = eventId => async dispatch => {
  try {
    dispatch({
      type: GET_MATCH_CARD_STATISTIC_MARKETS_REQUEST
    });

    const res = await axios.get(`${API_GATEWAY}/v3/mobile/aggregator/match-card/${eventId}/statistic-markets`);

    dispatch({
      type: GET_MATCH_CARD_STATISTIC_MARKETS_SUCCESS,
      payload: res.data,
      eventId: eventId
    });
  } catch (e) {

    dispatch({
      type: GET_MATCH_CARD_STATISTIC_MARKETS_FAILURE,
      payload: e.response && e.response.data || errorMessage
    });
  }
};


export const getMatchCardTribunCoupons = (eventId, feedId, loginStatus) => async (dispatch, getState) => {
  try {
    const requestBody = {
      eventId,
      max: 500000, // çekilen kuponların limit sayısı
      sortField: 'date',
      sortOrder: 'DESC',
      coupon: 'all',
      count: 30,
      channel: 'WEB',
      filterCount: '0',
      canBet: true,
      resultToday: false,
      category: 'both',
      min: 1,
      longTerm: false,
    };

    let appliedFilters;
    if (LocalStorage.get(SORT.localStorageKey) && LocalStorage.get(SORT.localStorageKey)['match-card']) {
      requestBody.sortField = LocalStorage.get(SORT.localStorageKey)['match-card'].sortField;
      requestBody.sortOrder = LocalStorage.get(SORT.localStorageKey)['match-card'].sortOrder;
    }

    const storedFilters = LocalStorage.get(FILTER_V2.appliedFiltersLocalStorageKey);
    if (storedFilters && storedFilters['match-card']) {
      appliedFilters = storedFilters['match-card'];
    } else {
      appliedFilters = FILTER_V2.defaultSelectedFilters;
    }
    Object.keys(appliedFilters).forEach(key => {
      requestBody[key] = appliedFilters[key];
    });

    if (feedId) {
      requestBody.offset = feedId;
    }

    dispatch({
      type: GET_MATCH_CARD_TRIBUN_COUPONS_REQUEST
    });

    const user = getState().auth.data;

    const res = await axios.post(replaceUrlWithPublicUrl(user, `${API_GATEWAY}/v2/mobile/tribun/feed/event`),
      requestBody,
      {
        headers: {
          channel: '0',
        }
      });

    dispatch({
      type: !feedId ? GET_MATCH_CARD_TRIBUN_COUPONS_SUCCESS : GET_MATCH_CARD_TRIBUN_COUPONS_LOADMORE_SUCCESS,
      payload: res.data.feeds,
      lastPage: res.data.lastPage
    });

    dispatch({
      type: SET_MATCHCARD_LAST_FEEDS,
      payload: res.data.feeds
    });
    
    dispatch(getTribunCouponDetails(null, res.data.feeds, false, loginStatus));
    
  } catch (e) {
    dispatch({
      type: GET_MATCH_CARD_TRIBUN_COUPONS_FAILURE,
      payload: e.response && e.response.data || errorMessage,
      lastPage: true
    });
  }
};


export const getPersonalMarketIds = eventId => async dispatch => {
  try {

    dispatch({
      type: GET_PERSONAL_MARKET_IDS_REQUEST
    });

    const requestBody = {
      eventIds: [eventId]
    };

    const res = await axios.post(`${API_GATEWAY}/v3/mobile/aggregator/gamelist/auth/events/recommended/markets`, requestBody);

    dispatch({
      type: GET_PERSONAL_MARKET_IDS_SUCCESS,
      payload: res.data.eventMarketIds[eventId]
    });

  } catch (e) {
    dispatch({
      type: GET_PERSONAL_MARKET_IDS_FAILURE,
      payload: e.response && e.response.data || errorMessage,
    });
  }
};

export const getPopularMarketIds = eventId => async dispatch => {
  try {

    dispatch({
      type: GET_POPULAR_MARKET_IDS_REQUEST
    });

    const res = await axios.get(`${API_GATEWAY}/v3/mobile/aggregator/gamelist/events/popular/markets?eventId=${eventId}`);

    dispatch({
      type: GET_POPULAR_MARKET_IDS_SUCCESS,
      payload: res.data.eventMarketIds[eventId]
    });

  } catch (e) {
    dispatch({
      type: GET_POPULAR_MARKET_IDS_FAILURE,
      payload: e.response && e.response.data || errorMessage,
    });
  }
};

export const getMatchCardImportantMoments = eventId => async dispatch => {
  try {
    dispatch({
      type: GET_MATCH_CARD_IMPORTANT_MOMENTS_REQUEST
    });

    const res = await axios.get(`${API_GATEWAY}/mobile/live-stream/perform/${eventId}/highlights`);


    dispatch({
      type: GET_MATCH_CARD_IMPORTANT_MOMENTS_SUCCESS,
      payload: res.data
    });
  } catch (e) {
    dispatch({
      type: GET_MATCH_CARD_IMPORTANT_MOMENTS_FAILURE,
      payload: e.response?.data || errorMessage
    });
  }
};

export const getImportantMomentsPlayUrl = (eventId, uuid) => async (dispatch, getState ) => {

  const externalCustomerId = getState().auth?.data?.externalCustomerId;

  try {
    dispatch({
      type: GET_IMPORTANT_MOMENTS_PLAYER_REQUEST
    });

    const res = await axios.get(`${API_GATEWAY}/mobile/live-stream/perform/${eventId}/highlights/${uuid}?externalCustomerId=${externalCustomerId}`);


    dispatch({
      type: GET_IMPORTANT_MOMENTS_PLAYER_SUCCESS,
      payload: res.data
    });
    const { authenticationUrl, performAuthenticationToken, statusCode } = res.data.authenticationResult;

    const options = {
      headers: {
        Authorization: 'Bearer ' + performAuthenticationToken,
        'pf-hostpage': 'https://www.bilyoner.com',
        Referer: 'https://www.bilyoner.com',
      }
    };

    if (statusCode === -2) {
      dispatch(openModal('liveStreamControlModal'));
      dispatch({
        type: AUTHENTICATE_IMPORTANT_MOMENT_STREAM_FAILURE,
        payload: statusCode
      });
    } else {
      dispatch({
        type: AUTHENTICATE_IMPORTANT_MOMENT_STREAM_REQUEST
      });

      fetch((authenticationUrl), options)
        .then(res => {
          if (res.status !== 204) {
            return res.json();
          }
          return Promise.resolve();
        })
        .then(response => {
          const launchUrl = getPerformLaunchUrl(response);
          if (!response || response.errorCode || !launchUrl) {
            dispatch({
              type: AUTHENTICATE_IMPORTANT_MOMENT_STREAM_FAILURE,
              payload: createLiveStreamGeoBlockError()
            });
          } else {
            dispatch({
              type: AUTHENTICATE_IMPORTANT_MOMENT_STREAM_SUCCESS,
              payload: {
                url: launchUrl,
                provider: 'PERFORM',
                streamId: eventId,
                performInfo: res.data.authenticationResult
              }
            });
          }
        })
        .catch(() => {
          dispatch({
            type: AUTHENTICATE_IMPORTANT_MOMENT_STREAM_FAILURE,
            payload: createLiveStreamGeoBlockError()
          });
        });
      dispatch(openModal('highlightPlayerModal', { type: 'video', url: res.data }));
    }
  } catch (e) {
    dispatch({
      type: GET_IMPORTANT_MOMENTS_PLAYER_FAILURE,
      payload: e.response?.data || errorMessage
    });
  }
};

export const getMultipleLmtHeader = eventId => async dispatch => {
  try {
    dispatch({
      type: GET_MULTIPLE_LMT_HEADER_REQUEST
    });

    const res = await axios.get(`/mobile/match-card/${eventId}/header/v9`);

    dispatch({
      type: GET_MULTIPLE_LMT_HEADER_SUCCESS,
      payload: { ...res.data, eventId }
    });

    return res.data;
  } catch (e) {
    dispatch({
      type: GET_MULTIPLE_LMT_HEADER_FAILURE,
      payload: e.response && e.response.data || errorMessage
    });
    throw e;
  }
};

export const getPlayerAnalysis = eventId => async (dispatch, getState) => {
  const eventIdInt = parseInt(eventId, 10);
  const state = getState();
  const cache = state.matchCard.playerAnalysis.cache[eventIdInt];
  const availabilityCache = state.matchCard.playerAnalysis.availabilityCache[eventIdInt];

  if (cache) {
    dispatch({
      type: GET_PLAYER_ANALYSIS_SUCCESS,
      payload: cache.data,
      eventId: eventIdInt
    });
    return cache.data;
  }

  if (availabilityCache && availabilityCache.data) {
    dispatch({
      type: GET_PLAYER_ANALYSIS_SUCCESS,
      payload: availabilityCache.data,
      eventId: eventIdInt
    });
    return availabilityCache.data;
  }

  try {
    dispatch({
      type: GET_PLAYER_ANALYSIS_REQUEST
    });

    const res = await axios.get(`${API_GATEWAY}/mobile/match-card/esport/analyses?eventId=${eventIdInt}`);

    const hasAnalysis = res.data && res.data.authors && res.data.authors.length > 0;

    dispatch({
      type: GET_PLAYER_ANALYSIS_SUCCESS,
      payload: res.data,
      eventId: eventIdInt
    });

    dispatch({
      type: CHECK_PLAYER_ANALYSIS_AVAILABILITY_SUCCESS,
      payload: { hasAnalysis, data: res.data },
      eventId: eventIdInt
    });

    return res.data;
  } catch (e) {
    dispatch({
      type: GET_PLAYER_ANALYSIS_FAILURE,
      payload: e.response && e.response.data || errorMessage
    });
    throw e;
  }
};

export const checkPlayerAnalysisAvailability = eventId => async (dispatch, getState) => {
  const eventIdInt = parseInt(eventId, 10);
  const state = getState();
  const cache = state.matchCard.playerAnalysis.availabilityCache[eventIdInt];

  if (cache) {
    dispatch({
      type: CHECK_PLAYER_ANALYSIS_AVAILABILITY_SUCCESS,
      payload: { hasAnalysis: cache.hasAnalysis, data: cache.data },
      eventId: eventIdInt
    });
    return cache.hasAnalysis;
  }

  try {
    dispatch({
      type: CHECK_PLAYER_ANALYSIS_AVAILABILITY_REQUEST
    });

    const res = await axios.get(`${API_GATEWAY}/mobile/match-card/esport/analyses?eventId=${eventIdInt}`);

    const hasAnalysis = res.data && res.data.authors && res.data.authors.length > 0;

    dispatch({
      type: CHECK_PLAYER_ANALYSIS_AVAILABILITY_SUCCESS,
      payload: { hasAnalysis, data: res.data },
      eventId: eventIdInt
    });

    return hasAnalysis;
  } catch (e) {
    dispatch({
      type: CHECK_PLAYER_ANALYSIS_AVAILABILITY_FAILURE,
      payload: e.response && e.response.data || errorMessage
    });
    return false;
  }
};

export const getMatchCardHeader = eventId => async (dispatch, getState) => {
  const requestKey = String(eventId);
  const headerState = getState()?.matchCard?.header;
  const cachedId = headerState?.data?.matchCode ?? headerState?.data?.eventId ?? headerState?.data?.id;

  // SSR loadData or a concurrent caller already resolved this event — skip refetch
  if (
    headerState?.isFetched
    && !headerState?.error
    && !headerState?.isLoading
    && cachedId != null
    && String(cachedId) === requestKey
  ) {
    return headerState.data;
  }

  if (inFlightHeaderRequests.has(requestKey)) {
    return inFlightHeaderRequests.get(requestKey);
  }

  const requestPromise = (async () => {
    try {
      dispatch({
        type: GET_MATCH_CARD_HEADER_REQUEST
      });

      const res = await axios.get(`${API_GATEWAY}/sports-data/matches/${eventId}/header`);

      const responseData = typeof res?.data === 'string' ? JSON.parse(res.data) : res?.data;

      dispatch({
        type: GET_MATCH_CARD_HEADER_SUCCESS,
        payload: responseData
      });

      trackMatchCard({ name: responseData?.eventName, id: responseData?.matchCode, brand: responseData?.sportType, category: responseData?.tournament?.tournamentName });

      return responseData;
    } catch (e) {
      dispatch({
        type: GET_MATCH_CARD_HEADER_FAILURE,
        payload: e.response && e.response.data || errorMessage
      });
      throw e;
    } finally {
      inFlightHeaderRequests.delete(requestKey);
    }
  })();

  inFlightHeaderRequests.set(requestKey, requestPromise);
  return requestPromise;
};

export const getMatchCardHeaderStatistics = (eventId, sportId) => async dispatch => {
  try {
    dispatch({ type: GET_MATCH_CARD_HEADER_STATISTICS_REQUEST });
    const res = await axios.get(`${API_GATEWAY}/sports-data/matches/${eventId}/statistics?sportTypeId=${sportId}`);
    dispatch({ type: GET_MATCH_CARD_HEADER_STATISTICS_SUCCESS, payload: res?.data });
  } catch (e) {
    dispatch({ type: GET_MATCH_CARD_HEADER_STATISTICS_FAILURE, payload: e.response?.data || errorMessage });
  }
};
